__turbopack_context__.v({
  "edit-button-wrapper": "styles-module__jrbRia__edit-button-wrapper",
});
